import i18n from '../../language/index'
import mp4img from '@/assets/yun_icon/MP4.png';
import swfimg from '@/assets/yun_icon/swf.png';
import { staticRule, chineseRule } from "@/base/valid";
import { getStaticStr } from "@/base/base";
export default {
  name: 'message',
  props: {
    tagList: {
      type: Array,
      default: () => [],
    },
    productInfor: {
      type: Object,
      default: null
    },
    treeData: {
      type: Array
    },
    articleWords: {
      type: String,
      default: i18n.t('widgets_basic_classification_edit_482')
    },
    total: {
      type: Number,
      default: 0
    },
    proParams: {
      type: Object,
      default: function() {
        return {
          title: i18n.t('components_basic_addproduct_index_2082'),
          type: 'add', // 类型： 新增（add）或编辑(edit)
          twebId: 0, // 网站ID
          pid: '0', // 分类类型pid
          id: '0', // 分类类型ID
          objectType: 'product', //  新增或编辑对象的类型 pro 分类类型
          typevalue: 1,
        };
      }
    }
  },
  data() {
    var myDate = new Date();
    var nowData = Date.parse(myDate);
    var summary_size = 2000
    var introLength = (rule, value, callback) => {
      if (this.wordslength > 70000) {
        callback(i18n.t('components_basic_addarticle_message_2017'));
      } else callback();
    };
    const validateContent = (rule, value, callback) => {
      if (typeof value == "string" && value.length > 100000) {
        callback(new Error(i18n.t('components_basic_addarticle_message_2018')));
      } else {
        callback();
      }
    };
    var chineseRuleValidator = (rule, value, callback) => {
        chineseRule(rule, value, callback,15)
    };
    return {
      typeTag: 0,
      isShow: false,
      filetype: 1, // 资源库选择的是图片 还是 视频
      change_name: '', // 资源库改变的是 imageUrl 还是 video_img，video_url
      tree_data: [],
      popShow: false,
      product_infor: this.productInfor,
      activeNames: [],
      limitnumber: 15,
      imageUrl: [],
      rules: {
        name: [{
            required: true,
            message: i18n.t('components_basic_addproduct_message_2091'),
            trigger: "blur"
          },
          {
            pattern: /\S+/,
            message: i18n.t('components_basic_addarticle_message_2020')
          },
          {
            min: 2,
            max: 200,
            message: i18n.t('components_basic_addarticle_message_2019'),
            trigger: "blur"
          },
          {
            validator: chineseRule,
            trigger: "blur"
          }
        ],
        intro: [{
          validator: introLength
        }],
        type_name: [{
          required: true,
          message: i18n.t('view_dialog_index_126'),
          trigger: 'change'
        }],
        sort: [{
          type: 'number',
          max: 99999,
          min: 0,
          message: i18n.t('components_basic_addarticle_message_2021'),
          trigger: 'blur'
        }],
        summary: [{
            required: true,
            message: i18n.t('components_basic_addproduct_message_2092'),
            trigger: 'blur'
          },
          {
            min: 20,
            max: summary_size,
            message: i18n.t('components_basic_addarticle_message_2022', [summary_size]),
            trigger: 'blur'
          },
          {
            validator: chineseRule,
            trigger: "blur"
          }
        ],
        pageviews: [{
          type: 'number',
          max: 99999,
          min: 0,
          message: i18n.t('components_basic_addarticle_message_2021'),
          trigger: 'blur'
        }],
        writer: [{
          min: 2,
          max: 8,
          message: i18n.t('components_basic_addproduct_message_2093'),
          trigger: 'blur'
        }],
        "tabs[0].content": [{
          validator: validateContent,
          trigger: "blur"
        }],
        "tabs[1].content": [{
          validator: validateContent,
          trigger: "blur"
        }],
        "tabs[2].content": [{
          validator: validateContent,
          trigger: "blur"
        }],
        "tabs[3].content": [{
          validator: validateContent,
          trigger: "blur"
        }],
        "tabs[4].content": [{
          validator: validateContent,
          trigger: "blur"
        }],
        "tabs[5].content": [{
          validator: validateContent,
          trigger: "blur"
        }],
        brand: [{
          max: 30,
          message: i18n.t('components_basic_addproduct_message_2094'),
          trigger: "blur"
        }, {
          validator: chineseRule,
          trigger: "blur"
        }],
        model: [{
          max: 30,
          message: i18n.t('components_basic_addproduct_message_2094'),
          trigger: "blur"
        }, {
          validator: chineseRule,
          trigger: "blur"
        }],
        minimum: [{
          type: "number",
          min: 0,
          message: i18n.t('components_basic_addproduct_message_2095'),
          trigger: "blur"
        }],
        standard: [{
          max: 30,
          message: i18n.t('components_basic_addproduct_message_2094'),
          trigger: "blur"
        }, {
          validator: chineseRule,
          trigger: "blur"
        }],
        unit: [{
          max: 20,
          message: i18n.t('components_basic_addproduct_message_2096'),
          trigger: "blur"
        }, {
          validator: chineseRule,
          trigger: "blur"
        }],
        pack: [{
          max: 30,
          message: i18n.t('components_basic_addproduct_message_2094'),
          trigger: "blur"
        }, {
          validator: chineseRule,
          trigger: "blur"
        }],
        static: [{
            max: 200,
            message: i18n.t('components_basic_addarticle_message_2025')
          },
          {
            validator: staticRule,
            trigger: "blur"
          }
        ]
      },
      ruleForm: {
        goods_id: '',
        name: '',
        pageviews: 0,
        album_ids: '', // 多个图片的ID
        type_name: '',
        type_id: '', //产品分类
        is_up: 'true', //是否发布
        is_nostore: 'true', //无库存销售
        bn: '', // 产品编码
        sort: 0, //产品排序
        img: '', //产品主图
        up_time: nowData,
        writer: '',
        imageUrl: [],
        summary: '', // 产品简介
        brand: '', //品牌
        standard: '', //规格
        model: '', //型号
        unit: '', //单位
        minimum: '', //起订量
        pack: '', //包装说明
        static: "", // 静态文件名
      },
      fifterTree: false,
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      autoSeo: {
        title: '',
        keywords: '',
        description: ''
      },
      attr_name_rules: [
      {
          validator: chineseRuleValidator,
          trigger: "blur"
      },
      {
        min: 0,
        max: 20,
        message: i18n.t('components_basic_addproduct_message_2097'),
        trigger: "blur"
      }],
      attr_value_rules: [
      {
          validator: chineseRuleValidator,
          trigger: "blur"
      },
      {
        min: 0,
        max: 30,
        message: i18n.t('components_basic_addproduct_message_2098'),
        trigger: "blur"
      }],
      rule_entry: false // 校验 进入的方式
    };
  },
  computed: {
    video_type() { // 视频封面显示
      let img = ''
      if (this.product_infor.video_url) {
        let type = this.product_infor.video_url.substring(this.product_infor.video_url.lastIndexOf(".") + 1);
        type = type.toLocaleLowerCase();
        // if (~"video/mp4".indexOf(type)) {
        let video_type = ['wmv', 'avi', 'mpg', 'mpeg', '3gp', 'mov', 'mp4', 'flv', 'f4v', 'm2t', 'mts', 'rmvb', 'vob', 'mkv']
        if (~video_type.indexOf(type)) {
          img = mp4img;
        } else if (~"video/swf".indexOf(type)) {
          img = swfimg;
        }
      }
      return img
    }
  },
  methods: {
    staticBlur() {
      this.product_infor.static = getStaticStr(this.product_infor.static);
    },
    attrNameValue(rule, value, callback, item, prop_value) { // 自定义属性 属性名blur 验证
      if(this.haveChinese(item.attr_name) || this.haveChinese(item.attr_value)){
        callback()
      }
      if ((value && item.attr_value)) {
        callback()
      }
      if (!value && !item.attr_value) {
        if (!this.rule_entry) {
          this.rule_entry = true
          this.$refs.product_infor.validateField(prop_value)
        } else this.rule_entry = false
        callback()
      }
      if (value && !item.attr_value) {
        this.$refs.product_infor.validateField(prop_value)
        callback()
      }
      if (!value && item.attr_value) {
        callback(i18n.t('components_basic_addproduct_message_2099'))
      }
    },
    attrValueName(rule, value, callback, item, prop_value) { // 自定义属性 属性名blur 验证
      if(this.haveChinese(item.attr_name) || this.haveChinese(item.attr_value)){
        callback()
      }
      if ((value && item.attr_name)) {
        // this.$refs.product_infor.validateField(prop_value)
        callback()
      }
      if (!value && !item.attr_name) {
        if (!this.rule_entry) {
          this.rule_entry = true
          this.$refs.product_infor.validateField(prop_value)
        } else this.rule_entry = false
        callback()
      }
      if (value && !item.attr_name) {
        this.$refs.product_infor.validateField(prop_value)
        callback()
      }

      if (!value && item.attr_name) {
        callback(i18n.t('components_basic_addproduct_message_2099'))
      }
    },
    attrValueChinese(rule, value, callback, item, index, _index){
      if(!this.haveChinese(value)){
        $('.custom-attr .attr-list').eq(index).find('.attr-list-item').eq(1-_index).find('.el-form-item__error').show()
        callback()
      }else{
        $('.custom-attr .attr-list').eq(index).find('.attr-list-item').eq(1-_index).find('.el-form-item__error').hide()
        $('.custom-attr .attr-list').eq(index).find('.attr-list-item').eq(_index).find('.el-form-item__error').show()
        chineseRule(rule, (item.attr_name + item.attr_value), callback,30)
      }      
    },
    haveChinese(value){
      const reg = /[\u4e00-\u9fa5]/g;
      if(this.$store.state.app.language == 'en-us' && reg.test(value)){
        return true;
      }else{
        return false;
      }
    },
    getNewType() {
      this.$emit('getTypes');
    },
    changemainpic(index) {
      let imglist = this.product_infor.imageUrl;
      let newlist = []
      newlist.push(this.product_infor.imageUrl[index])
      imglist.splice(index, 1)
      this.product_infor.imageUrl = newlist.concat(imglist)
    },
    closeVideo(name) { // 删除视频主图 或者是删除视频封面
      this.product_infor[name] = ''
    },
    closeavatar(index) {
      let data = this.product_infor.imageUrl
      data.splice(index, 1)
    },
    setSeoSummary(data) {
      this.autoSeo.description = data;
      if (this.autotype == 1) {
        this.product_infor.seo_description = this.autoSeo.description;
      }
    },
    setSeoTitle(data) {
      this.autoSeo.title = data;
      this.autoSeo.keywords = data;
      if (this.autotype == 1) {
        this.product_infor.seo_keywords = this.autoSeo.keywords;
        this.product_infor.seo_title = this.autoSeo.title;
      }
    },
    showpop(type, name) {
      const that = this;
      this.filetype = type;
      this.change_name = name;
      if (name === 'product_infor.imageUrl') {
        let limit = 15 - that.product_infor.imageUrl.length
        this.$store.commit('image_upload/set_fileType', 1);
        this.$store.commit('image_upload/set_showTag', true);
        this.$store.commit('image_upload/set_fileLimit', limit);
        this.$store.state.image_upload.imgFile = e => {
          let pathList = e.map(e => {
            e.img_path = e.filePath
            e.path = e.filePath
            return e
          })
          // that.product_infor.imageUrl = that.product_infor.imageUrl.concat(pathList)
          that.product_infor.imageUrl = that.templet.filterArray(that.product_infor.imageUrl, pathList, 'filePath')
          that.$store.state.image_upload.imgFile = null;
        };
      } else { // 产品的视频 和封面
        this.$store.commit('image_upload/set_fileType', this.filetype);
        this.$store.commit('image_upload/set_showTag', true);
        this.$store.commit('image_upload/set_fileLimit', 1);
        this.$store.state.image_upload.imgFile = e => {
          let pathList = e.map(e => {
            e.img_path = e.filePath
            e.path = e.filePath
            return e
          })
          if (that.change_name == 'product_infor.video_url' && pathList[0].fileSize / 1024 / 1024 > 50) {
            that.$message.warning(i18n.t('components_basic_addarticle_message_2027'));
            return false;
          }
          let name = that.change_name.split('.')
          that[name[0]][name[1]] = pathList[0].filePath;
          that.$store.state.image_upload.imgFile = null;
        };
      }

    },
    showTree() {
      this.fifterTree = true;
      this.$refs.tree2.filter('false');
    },
    cleanFifter() {
      //this.is_clean = true
    },
    hiddenTree() {
      this.fifterTree = false;
    },
    choseOrg(val) {
      this.product_infor.type_name = val.name;
      this.product_infor.type_id = val.id;
      this.product_infor.category_id = val.id;
      this.product_infor.category_name = val.name;
      this.fifterTree = false;
    },
    filterNode(value, data) {
      if (!value) return true;
      // return data.hide.indexOf(value) !== -1
      return true;
    },
    resetFields() {
      this.$refs.product_infor.resetFields()
    },
    openAddClass(isAddOrEdit, pid, id) {
      const info = isAddOrEdit === 'edit' ? i18n.t('components_basic_addarticle_index_2003') + this.articleWords + i18n.t('widgets_basic_article_info_edit_348') : i18n.t('components_add_button_index_1953') + this.articleWords + i18n.t('widgets_basic_article_info_edit_348');
      this.proParams.title = info;
      this.proParams.pid = pid;
      this.proParams.type = isAddOrEdit;
      this.proParams.id = id;
      this.isShow = true;
      if (this.proParams.objectType === 'product') {
        this.typeValue = 1;
      } else {
        this.typeValue = 2;
      }
    },
    setActiveNames(){
      if(this.activeNames.length == 0){
        this.activeNames.push("2")
      }
      return true;
    },
    scrollIntoError(){
      if(this.setActiveNames()){
        this.$nextTick(() => {
            let isError = document.getElementsByClassName("is-error");
            if (isError.length > 0) {
              isError[0].scrollIntoView({
                // 滚动到指定节点
                // 值有start,center,end，nearest，当前显示在视图区域中间
                block: "center",
                // 值有auto、instant,smooth，缓动动画（当前是慢速的）
                behavior: "smooth"
              });
            }
          });
      }      
    },
    addCustomAttr(){
      if (this.product_infor.custom_attr.length >= 8){
        return false;
      }
      this.product_infor.custom_attr.push({
        attr_name: '',
        attr_value: ''
      })
      
    },
    delCustomAttr(ind){
      this.product_infor.custom_attr.splice(ind, 1)
    }
  },
  watch: {
    product_infor(val) {
      this.$emit('update:productInfor', val); //双向数据绑定
    },
    productInfor(val) {
      this.product_infor = this.productInfor
    }
  },
  mounted() {}
};



// WEBPACK FOOTER //
// ./src/components/basic_addProduct/message.js